export default "__VITE_PUBLIC_ASSET__04b70502__"